<template>
    <div class="matrix-filter">
        <div class="filter-sort">
            <span>{{ __('Filter by') }}:</span>

            <form id="sort-form" action="">
                <button
                    v-for="order in availableOrderOptions"
                    :key="order.name"
                    :class="{ active: order.name === params.order }"
                    type="button"
                    @click="orderBy(order)"
                >
                   <span>{{ order.title }}</span>

                    <popover v-if="order.name === 'consultations'" class="popover" position="right">
                        <strong slot="header">{{ __('How in-app calling works') }}</strong>
                        <div class="popover__text" slot="content">
                            
                            <p>{{ __('In order to be able to make calls directly in the Vitadio app, it is necessary to have a complete dietitian profile with your personal phone number (the profile is set up by your coordinator/admin dietitian based on the information you provide).') }}</p>

                            <p>{{ __('✅ If everything is set up correctly and your phone number is working, you have the option of calling through your mobile phone or through a 3rd party app downloaded on your computer.') }}</p>

                            <p v-html="__('Then just click on the :icon icon for the patient where the call is first forwaded to your mobile phone (only for GER therapists) or the PC application where, after picking up, the call is immediately forwarded to the patient (in both cases, the patient does not see your personal number but our centralised number for the given country).', { icon: icon } )"></p>

                            <p>{{ __('☎️ Mobile phone calls generally have a better signal but are also more expensive, so if possible, use the more convenient option of a SIP device on your PC with a headset.') }}</p>

                            <p>{{ __('⛔ Patients cannot call back in the case of these “In-app“ calls and always get an automated voice message to contact you via chat if needed.') }}</p>

                            <p>{{ __('Learn more:') }}</p>
                        
                            <ul>
                                <li><a href="https://www.notion.so/vitadiohealth/How-To-Set-up-SIP-calling-device-3rd-party-app-on-my-PC-62dc6caae92344c6969e204808241772?pvs=4" target="_blank" rel="noopener noreferrer">How to set-up SIP calling device (3rd party app) on my PC (Notion)</a></li>
                            </ul>
                        </div>
                    </popover>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            availableOrderOptions: [
                { name: 'all', title: this.__('All') },
                { name: 'consultations', title: this.__('Consultation') },
                { name: 'notes', title: this.__('Reminders') },
                { name: 'events', title: this.__('Update') },
                { name: 'prescription_end', title: this.__('Prescription end') },
                { name: 'last_login', title: this.__('Last login') },
            ],
            params: {
                order: 'all',
            },
            icon: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.447018 0.590579L2.94231 0.0148149C3.21376 -0.0478312 3.49124 0.0928406 3.60106 0.349064L4.75273 3.03622C4.85379 3.27204 4.78666 3.54627 4.58809 3.70873L3.1337 4.89869C3.9968 6.73837 5.50753 8.26992 7.38646 9.15143L8.57642 7.69706C8.73888 7.4985 9.01311 7.43136 9.24893 7.53242L11.9361 8.68409C12.1922 8.79386 12.333 9.07132 12.2703 9.34285L11.6946 11.8381C11.6347 12.0974 11.4035 12.2845 11.1335 12.2845C4.98916 12.2845 0.000673532 7.30513 0.000673532 1.15166C0.000673532 0.883511 0.185757 0.650849 0.447018 0.590579Z" fill="#C193FF"/></svg>'
        }
    },
    watch: {
        params: {
            handler: _.debounce(function() {
                this.$emit('change', this.params)
            }, 300),
            deep: true
        }
    },
    methods: {
        orderBy(order) {
            this.params.order = order.name
        }
    }
}
</script>
